<script setup lang="ts">
import { computed } from 'vue'
import { NXGDSStatusIcon } from '@nsftx/seven-nxg-design-system'
import { useOnlineStatus } from '@nsftx/seven-client-retail-vue-common'

const { isOnline } = useOnlineStatus()

const networkStatusIconProps = computed(() =>
  isOnline.value
    ? ({ icon: 'radio-a-ng', variant: 'positive' } as const)
    : ({ icon: 'offline', variant: 'negative' } as const),
)
</script>

<template>
  <NXGDSStatusIcon v-bind="networkStatusIconProps" />
</template>
